import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { stringify } from 'query-string';
import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { propArrayShape, propStr } from '../../../../helpers/custom-prop-types';
const PsSlideOneContent = (props) => {
    const { tags, title } = props;
    const linkTags = useMemo(() => tags.map((tag) => (Object.assign(Object.assign({}, tag), { link: `/consultant/search?${stringify({
            keyword: tag.name,
            psSlideTypes: `[${tag.id}]`,
            search: 'psSlide',
        })}` }))), [tags]);
    return (_jsxs("div", Object.assign({ className: 'page_content' }, { children: [_jsx("h2", Object.assign({ className: 'content_title' }, { children: title })), _jsx("div", Object.assign({ className: 'content_tag_box' }, { children: _jsx("ul", Object.assign({ className: 'content_tags' }, { children: linkTags.map((linkTag) => (_jsx("li", Object.assign({ className: 'content_tag' }, { children: _jsx(Link, Object.assign({ className: 'content_tag_link', to: linkTag.link }, { children: `#${linkTag.name}` })) }), linkTag.id))) })) }))] })));
};
PsSlideOneContent.propTypes = {
    tags: propArrayShape().isRequired,
    title: propStr().isRequired,
};
export default PsSlideOneContent;
